import api from "@/libs/api";
import store from "@/store";

const initState = {
    attr_data: "",
    attr_book_show: "",
};

const attribution = {
    state: initState,
    mutations: {
        SET_ATTR_DATA(state, proload) {
            state.attr_data = proload
        },
        SET_ATTR_URL(state, url) {
            state.attr_book_show = url
        },
    },
    getters: {},
    actions: {},
};

export default attribution;


// WEBPACK FOOTER //
// ./src/store/modules/attribution.js